// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"fd1de5d2","962":"df2d513c"}[chunkId] + ".chunk.js";
};